"use client";

import { cn } from "@punchup/utils";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../shadcn/ui/tooltip";

interface BetaBadgeProps {
  label?: string;
  tooltip?: string;
  onClick?: () => void;
  className?: string;
}

export function BetaBadge({
  label = "Beta",
  tooltip,
  onClick,
  className,
}: BetaBadgeProps) {
  const badge = (
    <span
      className={cn(
        "inline-flex select-none items-center justify-center rounded-full bg-[var(--punchup-color-badge-bg)] px-3 py-0.5 text-xs font-normal text-[var(--punchup-color-badge-text)]",
        className
      )}
    >
      {label}
    </span>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="cursor-pointer focus:outline-none rounded-full"
      >
        {badge}
      </button>
    );
  }

  if (!tooltip) return badge;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{badge}</TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
